function updateFreeShipping(cart) {
  const barWrapper = document.getElementById("free-shipping-bar");
  if (!barWrapper) return;

  const textEl = barWrapper.querySelector("#free-shipping-text");
  const progressBar = barWrapper.querySelector(".free-shipping-progress-bar");

  const threshold = parseInt(barWrapper.dataset.threshold);

  function formatMoney(cents) {
    return (cents / 100).toLocaleString("nl-NL", {
      style: "currency",
      currency: "EUR"
    });
  }

  const cartTotal = cart.total_price;

  if (cartTotal >= threshold) {
    textEl.innerText = "🎉 Gratis verzending bereikt!";
    progressBar.style.width = "100%";
  } else {
    const remaining = threshold - cartTotal;
    const progress = Math.min((cartTotal / threshold) * 100, 100);

    textEl.innerText = `Nog ${formatMoney(remaining)} tot gratis verzending`;
    progressBar.style.width = progress + "%";
  }
}

// ✅ INIT (bij laden)
function initFreeShipping() {
  fetch("/cart.js")
    .then(res => res.json())
    .then(cart => updateFreeShipping(cart));
}

document.addEventListener("DOMContentLoaded", initFreeShipping);


/// 🔥 BELANGRIJKSTE DEEL — echte fix
/// onderschept Shopify cart updates meteen

const originalFetch = window.fetch;

window.fetch = function () {
  return originalFetch.apply(this, arguments).then((response) => {

    // check of het een cart update is
    if (response.url.includes("/cart") && response.clone) {
      response.clone().json().then((data) => {

        // alleen reageren als het echt cart data is
        if (data && typeof data.total_price !== "undefined") {
          updateFreeShipping(data);
        }

      }).catch(() => {});
    }

    return response;
  });
};

if (progress > 80 && cartTotal < threshold) {
  textEl.innerText = `🔥 Bijna gratis verzending! Nog ${formatMoney(remaining)}`;
}